module.exports = __webpack_public_path__ + "assets/img/8358-my.svg";